import React, { Component } from "react";
import axios from "axios";
import { v4 as uuid } from "uuid";
import Challenge from "./Challenge";

const config = require("../config.json");

export default class ChallengeAdmin extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.convertUnix = this.convertUnix.bind(this);
  }

  state = {
    newChallenge: {
      challengeName_da: "",
      challengeName_en: "",
      challengeHidden: false,
      challengeImage: "",
      description_da: "",
      description_en: "",
      id: uuid(),
      startDate: 0,
      endDate: 0,
      activityPacks: { defaultPack: "" },
      quizPacks: { defaultPack: "" },
      amountOfQuizzesPerDay: 0,
      notificationPack: "",
      timePeriod: 0,
      timePeriodName: "day",
      activitiesPerPeriod: 0,
      roundAmount: 0,
    },
    campaignImages: [],
    challenges: [],
    activityPacks: [],
    notificationPacks: [],
    quizPacks: [],
    loading: false,
  };

  handleAddChallenge = async (challenge, event) => {
    event.preventDefault();
    try {
      const params = {
        id: challenge.id,
        challengeName_da: challenge.challengeName_da,
        challengeName_en: challenge.challengeName_en,
        challengeHidden: false,
        startDate: parseInt(this.convertUnix(challenge.startDate)),
        endDate: parseInt(this.convertUnix(challenge.endDate)),
        activityPacks: challenge.activityPacks,
        quizPacks: challenge.quizPacks,
        notificationPack: challenge.notificationPack,
        challengeImage: challenge.challengeImage,
        description_da: challenge.description_da,
        description_en: challenge.description_en,
        timePeriod: parseInt(challenge.timePeriod),
        timePeriodName: challenge.timePeriodName,
        activitiesPerPeriod: parseInt(challenge.activitiesPerPeriod),
        amountOfQuizzesPerDay: challenge.amountOfQuizzesPerDay,
        roundAmount: challenge.roundAmount,
      };

      await axios.post(
        `${config.api.invokeUrl}/challenges/${challenge.id}`,
        params
      );

      this.setState({
        challenges: [
          ...this.state.challenges,
          {
            ...this.state.newChallenge,
            startDate: parseInt(this.convertUnix(challenge.startDate)),
            endDate: parseInt(this.convertUnix(challenge.endDate)),
          },
        ],
      });
      this.setState({
        newChallenge: {
          challengeName_da: "",
          challengeName_en: "",
          challengeHidden: false,
          id: uuid(),
          startDate: "",
          endDate: "",
          activityPacks: { defaultPack: "" },
          quizPacks: { defaultPack: "" },
          notificationPack: "",
          challengeImage: "",
          description_da: "",
          description_en: "",
          timePeriod: 0,
          roundAmount: 0,
          timePeriodName: "day",
          activitiesPerPeriod: 0,
          amountOfQuizzesPerDay: 0,
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleUpdateChallenge = async (challenge) => {
    try {
      const params = {
        id: challenge.id,
        challengeName_da: challenge.challengeName_da,
        challengeName_en: challenge.challengeName_en,
        challengeHidden: false,
        startDate: parseInt(this.convertUnix(challenge.startDate)),
        endDate: parseInt(this.convertUnix(challenge.endDate)),
        activityPacks: challenge.activityPacks,
        quizPacks: challenge.quizPacks,
        notificationPack: challenge.notificationPack,
        challengeImage: challenge.challengeImage,
        description_da: challenge.description_da,
        description_en: challenge.description_en,
        timePeriod: parseInt(challenge.timePeriod),
        timePeriodName: challenge.timePeriodName,
        activitiesPerPeriod: parseInt(challenge.activitiesPerPeriod),
        amountOfQuizzesPerDay: challenge.amountOfQuizzesPerDay,
        roundAmount: challenge.roundAmount,
      };
      await axios.patch(
        `${config.api.invokeUrl}/challenges/${challenge.id}`,
        params
      );
    } catch (err) {
      console.log(err);
    }

    const updatedChallenges = [...this.state.challenges].filter(
      (c) => c.id !== challenge.id
    );
    updatedChallenges.push({
      ...challenge,
      startDate: parseInt(this.convertUnix(challenge.startDate)),
      endDate: parseInt(this.convertUnix(challenge.endDate)),
    });
    this.setState({ challenges: updatedChallenges });
  };

  handleDeleteChallenge = async (id, event) => {
    event.preventDefault();
    if (window.confirm(" Er du sikker?")) {
      try {
        await axios.delete(`${config.api.invokeUrl}/challenges/${id}`);
      } catch (err) {
        console.log(err);
      }
      const updatedChallenges = [...this.state.challenges].filter(
        (challenge) => challenge.id !== id
      );
      this.setState({ challenges: updatedChallenges });
    }
  };

  fetchChallenges = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/challenges`);
      const challenges = res.data;
      challenges.sort(
        (challengeA, challengeB) =>
          challengeA.challengeHidden > challengeB.challengeHidden
      );
      this.setState({ challenges: challenges });
    } catch (err) {
      console.log(err);
    }
  };

  fetchActivityPacks = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/activities/packs/`);
      const activityPacks = res.data;
      this.setState({ activityPacks: activityPacks });
    } catch (err) {
      console.log(err);
    }
  };

  fetchNotificationPacks = async () => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/notification/packs/`
      );
      const notificationPacks = res.data;
      this.setState({ notificationPacks: notificationPacks });
    } catch (err) {
      console.log(err);
    }
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    let difference = 0;

    if (target.name == "endDate") {
      difference =
        parseInt(this.convertUnix(value)) -
        parseInt(this.convertUnix(this.state.newChallenge.startDate));
    } else if (target.name == "startDate") {
      difference =
        parseInt(this.convertUnix(this.state.newChallenge.endDate)) -
        parseInt(this.convertUnix(value));
    } else {
      difference =
        parseInt(this.convertUnix(this.state.newChallenge.endDate)) -
        parseInt(this.convertUnix(this.state.newChallenge.startDate));
    }

    let timePeriod = this.state.newChallenge.timePeriod;
    if (target.name == "timePeriod") {
      timePeriod = value;
    }

    let roundAmount = difference / parseInt(timePeriod);

    if (isNaN(roundAmount) || roundAmount < 0) {
      roundAmount == 0;
    }

    this.setState({
      newChallenge: {
        ...this.state.newChallenge,
        [name]: value,
        roundAmount: roundAmount,
      },
    });
  }

  onActivityPackChange = (e) => {
    const select = e.target;
    const value = select.options[select.selectedIndex].value;

    if (select.id === "activityPackDefault") {
      this.setState({
        newChallenge: {
          ...this.state.newChallenge,
          activityPacks: {
            ...this.state.newChallenge.activityPacks,
            defaultPack: value,
          },
        },
      });
    } else {
      const period = parseInt(select.id.split("activityPack")[1]);
      this.setState({
        newChallenge: {
          ...this.state.newChallenge,
          activityPacks: {
            ...this.state.newChallenge.activityPacks,
            [period]: value,
          },
        },
      });
    }
  };

  onQuizPackChange = (e) => {
    const select = e.target;
    const value = select.options[select.selectedIndex].value;

    if (select.id === "quizPackDefault") {
      this.setState({
        newChallenge: {
          ...this.state.newChallenge,
          quizPacks: {
            ...this.state.newChallenge.quizPacks,
            defaultPack: value,
          },
        },
      });
    } else {
      const week = parseInt(select.id.split("quizPack")[1]);
      this.setState({
        newChallenge: {
          ...this.state.newChallenge,
          quizPacks: {
            ...this.state.newChallenge.quizPacks,
            [week]: value,
          },
        },
      });
    }
  };

  convertUnix(dateOrUnix) {
    if (typeof dateOrUnix == "number") {
      const options = {
        timeZone: "Europe/Copenhagen",
        hour: "2-digit",
        minute: "2-digit",
        month: "2-digit",
        year: "numeric",
        day: "2-digit",
      };
      const date = new Date(dateOrUnix);
      return date.toLocaleDateString("da-DK", options);
    } else if (typeof dateOrUnix == "object") {
      return Math.floor(dateOrUnix.getTime() / 1000);
    } else if (typeof dateOrUnix == "string") {
      return Math.floor(new Date(dateOrUnix).getTime() / 1000);
    }
  }

  fetchCampaignImages = async () => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/images?bucketName=${config.s3.campaignImagesBucket}`
      );
      if (res.data?.Contents) {
        const campaignImages = res.data.Contents;
        this.setState({ campaignImages });
      }
    } catch (err) {
      console.log(err);
    }
  };

  fetchQuizPacks = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/quiz/packs/`);
      const quizPacks = res.data;
      this.setState({ quizPacks: quizPacks });
    } catch (err) {
      console.log(err);
    }
  };

  componentDidMount = () => {
    this.fetchAll();
  };

  fetchAll = async () => {
    this.setState({ loading: true });
    let promise = await Promise.all([
      this.fetchActivityPacks(),
      this.fetchChallenges(),
      this.fetchNotificationPacks(),
      this.fetchCampaignImages(),
      this.fetchQuizPacks(),
    ]);
    this.setState({ loading: false });
  };

  render() {
    return !this.state.loading ? (
      <>
        <section className="section">
          <div className="container">
            <h1>Challenge Admin</h1>
            <p className="subtitle is-5">Tilføj og fjern Challenges</p>
            <br />
            <div className="columns is-multiline is-flex-direction-column">
              <div className="column is-full">
                <form
                  onSubmit={(event) =>
                    this.handleAddChallenge(this.state.newChallenge, event)
                  }
                >
                  <div className="field">
                    <div className="control">
                      <input
                        className="input is-medium"
                        type="text"
                        name="challengeName_da"
                        placeholder="Dansk navn"
                        required
                        value={this.state.newChallenge.challengeName_da}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="control">
                      <input
                        className="input is-medium"
                        type="text"
                        name="challengeName_en"
                        placeholder="Engelsk navn"
                        required
                        value={this.state.newChallenge.challengeName_en}
                        onChange={this.handleInputChange}
                      />
                    </div>

                    <textarea
                      name="description_da"
                      className="textarea"
                      placeholder="Dansk Beskrivelse"
                      value={this.state.newChallenge.description_da}
                      onChange={this.handleInputChange}
                    />
                    <textarea
                      name="description_en"
                      className="textarea"
                      placeholder="ENGELSK Beskrivelse "
                      value={this.state.newChallenge.description_en}
                      onChange={this.handleInputChange}
                    />

                    <div
                      className="control is-flex"
                      style={{ flexDirection: "column", maxWidth: 250 }}
                    >
                      Tidsperiode i SEKUNDER
                      <input
                        type={"text"}
                        name={"timePeriod"}
                        onChange={this.handleInputChange}
                        value={this.state.newChallenge.timePeriod}
                      />
                      Start:
                      <input
                        type={"datetime-local"}
                        name={"startDate"}
                        onChange={this.handleInputChange}
                        value={this.state.newChallenge.startDate}
                      />
                      Slut:
                      <input
                        type={"datetime-local"}
                        name={"endDate"}
                        onChange={this.handleInputChange}
                        value={this.state.newChallenge.endDate}
                      />
                      Tidsperiode navn
                      <select
                        className="select is-medium"
                        type={"text"}
                        name={"timePeriodName"}
                        id={"timePeriodName"}
                        onChange={this.handleInputChange}
                        defaultValue={"day"}
                      >
                        <option value={"day"}>Dag</option>
                        <option value={"week"}>Uge</option>
                        <option value={"round"}>Runde</option>
                      </select>
                      Aktivitetskrav per periode
                      <input
                        type={"number"}
                        name={"activitiesPerPeriod"}
                        onChange={this.handleInputChange}
                        value={this.state.newChallenge.activitiesPerPeriod}
                      />
                      <div style={{ flexDirection: "row", display: "flex" }}>
                        <div>
                          Aktiviteter Grundpakke
                          <select
                            className="select is-medium"
                            name={`activityPackDefault`}
                            id={"activityPackDefault"}
                            onChange={this.onActivityPackChange}
                            defaultValue={"def"}
                          >
                            <option id={"def"} value=""></option>
                            {this.state.activityPacks.map((ap, idx) => {
                              return (
                                <option key={ap.id + idx} value={ap.id}>
                                  {ap.packName}
                                </option>
                              );
                            })}
                          </select>
                          {Array.from(
                            {
                              length: parseInt(
                                this.state.newChallenge.roundAmount
                              ),
                            },
                            (_, index) => index + 1
                          ).map((period) => {
                            return (
                              <div key={`activityPack${period}`}>
                                Aktiviteter Uge {period}
                                <select
                                  className="select is-medium"
                                  name={`activityPack${period}`}
                                  id={`activityPack${period}`}
                                  onChange={this.onActivityPackChange}
                                  defaultValue={"def"}
                                >
                                  <option id={"def"} value=""></option>
                                  {this.state.activityPacks.map((ap) => {
                                    return (
                                      <option
                                        key={ap.id + period}
                                        value={ap.id}
                                      >
                                        {ap.packName}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            );
                          })}
                        </div>

                        <div
                          style={{
                            minWidth: "300px",
                            flexDirection: "column",
                            display: "flex",
                            marginLeft: "10px",
                          }}
                        >
                          Quiz Grundpakke
                          <select
                            className="select is-medium"
                            name={`quizPackDefault`}
                            id={"quizPackDefault"}
                            onChange={this.onQuizPackChange}
                            defaultValue={"def"}
                          >
                            <option id={"def"} value=""></option>
                            {this.state.quizPacks.map((ap, idx) => {
                              return (
                                <option key={ap.id + idx} value={ap.id}>
                                  {ap.packName}
                                </option>
                              );
                            })}
                          </select>
                          {Array.from(
                            {
                              length: parseInt(
                                this.state.newChallenge.roundAmount
                              ),
                            },
                            (_, index) => index + 1
                          ).map((period) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  minWidth: "300px",
                                }}
                                key={`quizPack${period}`}
                              >
                                Quizpakke Uge {period}
                                <select
                                  className="select is-medium"
                                  name={`quizPack${period}`}
                                  id={`quizPack${period}`}
                                  onChange={this.onQuizPackChange}
                                  defaultValue={"def"}
                                >
                                  <option id={"def"} value=""></option>
                                  {this.state.quizPacks.map((ap) => {
                                    return (
                                      <option
                                        key={ap.id + period}
                                        value={ap.id}
                                      >
                                        {ap.packName}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <p>Antal quizzer om dagen</p>
                      <input
                        type={"number"}
                        name={"amountOfQuizzesPerDay"}
                        onChange={this.handleInputChange}
                        value={this.state.newChallenge.amountOfQuizzesPerDay}
                      />
                      <>
                        Notifikationspakke
                        <select
                          className="select is-medium"
                          name={`notificationPack`}
                          onChange={this.handleInputChange}
                          defaultValue={""}
                        >
                          <option id={""} value=""></option>
                          {this.state.notificationPacks.map((ap, idx) => {
                            return (
                              <option key={ap.id + idx} value={ap.id}>
                                {ap.packName}
                              </option>
                            );
                          })}
                        </select>
                      </>
                      <div
                        className="control"
                        style={{ marginTop: 10, marginBottom: 10 }}
                      >
                        Billede:
                        <select
                          name="challengeImage"
                          value={this.state.newChallenge.challengeImage}
                          onChange={this.handleInputChange}
                        >
                          <option value=""></option>
                          {this.state.campaignImages.map((challengeImage) => {
                            return (
                              <option
                                key={challengeImage.Key}
                                value={challengeImage.Key}
                              >
                                {challengeImage.Key}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <button
                        type="submit"
                        className="button is-primary is-medium"
                      >
                        Tilføj
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="column">
                <div className="tile is-ancestor ">
                  <div className="tile is-parent flex-wrap">
                    {this.state.challenges.map((challenge) => (
                      <Challenge
                        handleUpdateChallenge={this.handleUpdateChallenge}
                        handleDeleteChallenge={this.handleDeleteChallenge}
                        convertUnix={this.convertUnix}
                        challenge={challenge}
                        activityPacks={this.state.activityPacks}
                        notificationPacks={this.state.notificationPacks}
                        challengeImages={this.state.campaignImages}
                        quizPacks={this.state.quizPacks}
                        key={challenge.id}
                        isAdmin={true}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    ) : (
      <></>
    );
  }
}
